import axios from "axios";

export const getAllAkuns = async () => {
  return await axios.get(`${window._HOST}admin/akuns`, {
    withCredentials: true,
  });
};

export const getAllDetailAkuns = async () => {
  return await axios.get(`${window._HOST}admin/akuns/detail`, {
    withCredentials: true,
  });
};

export const getAllDataTableAkuns = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/akuns/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/akuns/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const getDropdownAkuns = async () => {
  return await axios.get(`${window._HOST}admin/akuns/dropdown`, {
    withCredentials: true,
  });
};

export const getDropdownAkunsDebet = async () => {
  return await axios.get(`${window._HOST}admin/akuns/dropdownDebet`, {
    withCredentials: true,
  });
};

export const getDropdownAkunsKredit = async () => {
  return await axios.get(`${window._HOST}admin/akuns/dropdownKredit`, {
    withCredentials: true,
  });
};

export const getDropdownKodeAkun = async () => {
  return await axios.get(`${window._HOST}admin/akuns/dropdownKodeAkun`, {
    withCredentials: true,
  });
};

export const getDropdownKodeAkunOnlyKas = async () => {
  return await axios.get(`${window._HOST}admin/akuns/dropdownOnlyKas`, {
    withCredentials: true,
  });
};

export const getFilteredKodeAkun = async (condition) => {
  return await axios.post(
    `${window._HOST}admin/akuns/filteredData`,
    condition,
    { withCredentials: true }
  );
};

export const insertNewAkun = async (formData) => {
  return await axios.post(`${window._HOST}admin/akuns`, formData, {
    withCredentials: true,
  });
};

export const updateAkun = async (id_sistem_akun, formData) => {
  return await axios.put(
    `${window._HOST}admin/akuns/${id_sistem_akun}`,
    formData,
    { withCredentials: true }
  );
};

export const deleteAkun = async (id_sistem_akun) => {
  return await axios.delete(`${window._HOST}admin/akuns/${id_sistem_akun}`, {
    withCredentials: true,
  });
};
